export { ModulesNames } from 'apps/api/src/app/consts/modules.const';
